module.exports = { id: "target", url: "/build/app/img/symbols.svg#target", viewBox: "", toString: function() { return this.url; } };